import { CPF, CNPJ } from 'cpf_cnpj'
const message = 'O CPF/CNPJ informado não é valido.'

/**
 * Objeto no formato de validator do vee-validate.
 * Usado para estender o validator padrão e criar uma nova rule.
 */
export default {
  messages: {
    ptBR: () => message
  },
  validate(value) {
    return CPF.isValid(value) || CNPJ.isValid(value)
  }
}
